import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import WarningIcon from '@material-ui/icons/Warning';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';

export default function DeleteAllPopUp(props) {
  const { openDeletePopUp } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  function closeDeletePopUp() {
    props.closeDeletePopUp();
  }

  function confirmDeletion() {
    props.confirmDeletion();
  }

  return (
    <Dialog
      open={openDeletePopUp}
      onClose={closeDeletePopUp}
      maxWidth="md"
      classes={{ paper: classes.paper }}
    >
      <Grid container spacing={0}>
        <Grid item xs={1}>
          <WarningIcon className={classes.warningIcon} fontSize="large" />
        </Grid>
        <Grid item xs={11}>
          <DialogTitle className={classes.dialogTitle}>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>
                <Typography className={classes.title}>
                  {t('You are deleting all invoices')}
                </Typography>
              </Box>
              <Box>
                <IconButton onClick={closeDeletePopUp} aria-label="close">
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <DialogContentText className={classes.dialogText}>
              {t('Do you want to delete all invoices')}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button
              aria-label="close"
              className={classes.cancelButton}
              onClick={closeDeletePopUp}
              color="secondary"
              variant="outlined"
            >
              {t('Cancel')}
            </Button>
            <Button
              aria-label="validate"
              className={classes.validateButton}
              onClick={confirmDeletion}
              color="secondary"
              variant="contained"
              autoFocus
            >
              {t('Validate')}
            </Button>
          </DialogActions>
        </Grid>
      </Grid>
    </Dialog>
  );
}
